import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import ConditionalComponent from './ConditionalComponent';


const PerformanceDeltasComponent = ({
  primaryName,
  secondaryName,
  durDelta
}) => (
  <ConditionalComponent condition={(primaryName || secondaryName) !== undefined}>
    <Row>
      <fieldset>
        <legend>
          Deltas: {`${primaryName ? primaryName : 'None Selected'} --\
            ${secondaryName ? secondaryName + ' (Baseline)' : 'None Selected'}`}
        </legend>
      </fieldset>
    </Row>
    <Row>
      <Col md={6}><b>Durations</b></Col>
    </Row>
    <Row>
      <Col md={2}>Duration: {durDelta}% </Col>
    </Row>
  </ConditionalComponent>
);

PerformanceDeltasComponent.propTypes = {
  primaryName: PropTypes.string,
  secondaryName: PropTypes.string,
  durDelta: PropTypes.string.isRequired
};

export default PerformanceDeltasComponent;


// WEBPACK FOOTER //
// src/Components/PerformanceDeltasComponent.jsx